module.exports = __webpack_public_path__ + "img/toad-pad.c742c6b0.svg";